var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComboIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 64,
    viewBox: "0 0 54 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3385 23.7949C44.3385 33.4615 36.5022 41.2978 26.8356 41.2978C17.1691 41.2978 9.33276 33.4615 9.33276 23.7949C9.33276 21.3769 9.82246 19.5064 10.6783 18.0537C11.5327 16.6034 12.7723 15.5351 14.3303 14.7519C17.4728 13.1721 21.8662 12.7725 26.8356 12.7725C31.805 12.7725 36.1985 13.1721 39.341 14.7519C40.8989 15.5351 42.1385 16.6034 42.9929 18.0537C43.8488 19.5064 44.3385 21.3769 44.3385 23.7949Z",
    stroke: "url(#paint0_radial_177:16)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.7679,
    cy: 24.6233,
    r: 3.70823,
    stroke: "url(#paint1_radial_177:16)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8357,
    cy: 24.6233,
    r: 3.70823,
    stroke: "url(#paint2_radial_177:16)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6274,
    cy: 33.7654,
    r: 3.70823,
    stroke: "url(#paint3_radial_177:16)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3199,
    cy: 45.9532,
    r: 2.79645,
    stroke: "url(#paint4_radial_177:16)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1292,
    cy: 16.9825,
    r: 2.21,
    stroke: "url(#paint5_radial_177:16)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6402,
    cy: 33.7654,
    r: 3.70823,
    stroke: "url(#paint6_radial_177:16)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.3515,
    cy: 45.9532,
    r: 2.79645,
    stroke: "url(#paint7_radial_177:16)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.142,
    cy: 16.9825,
    r: 2.21,
    stroke: "url(#paint8_radial_177:16)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1131,
    cy: 24.6233,
    r: 3.70823,
    stroke: "url(#paint9_radial_177:16)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1951,
    y: 41.3247,
    width: 25.281,
    height: 9.25681,
    stroke: "url(#paint10_radial_177:16)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.858246,
    y: 0.539062,
    width: 51.9547,
    height: 62.2759,
    rx: 4.5,
    stroke: "url(#paint11_radial_177:16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8342 40.4952) rotate(-59.2528) scale(41.4274 46.1947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6638 28.4602) rotate(-63.9967) scale(11.2924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7316 28.4602) rotate(-63.9967) scale(11.2924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5233 37.6023) rotate(-63.9967) scale(11.2924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6717 48.9588) rotate(-63.9967) scale(8.84572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7742 19.4533) rotate(-63.9967) scale(7.27204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5361 37.6023) rotate(-63.9967) scale(11.2924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7033 48.9588) rotate(-63.9967) scale(8.84572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.787 19.4533) rotate(-63.9967) scale(7.27204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.009 28.4602) rotate(-63.9967) scale(11.2924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2653 50.629) rotate(-38.662) scale(19.7983 24.5098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_177:16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5969 60.5233) rotate(-67.7929) scale(82.4166 73.1884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboIcon);
export default __webpack_public_path__ + "static/media/combo_icon.a86a7299.svg";
export { ForwardRef as ReactComponent };